import styled from "@emotion/styled"
import { ParentPage } from "lib/utils"
import SmallChargeIcon from "public/icons/pazCharge/Logo/smallChargeLogo"
import { CustomBreadcrumbs, ImageContainer } from "ui"

const StyledImageWrapper = styled.div`
    padding-left: 20px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 150px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 220px;
  }
`

type Props = {
    desktopUrl: string,
    mobileUrl: string,
    parents: ParentPage[]
    pageName: string
    paddingBottom?: number
}
function ArticleImageHeader({ desktopUrl, mobileUrl, parents, pageName, paddingBottom }: Props) {
    return (
        <StyledImageWrapper>
            <CustomBreadcrumbs
                current={{ title: pageName, url: `/` }}
                firstItemIconTextUnderline
                parents={[{
                    title: <SmallChargeIcon />,
                    url: "/pazcharge"
                }, ...parents.slice(0, -1)]}
            />
            <ImageContainer
                desktopUrl={desktopUrl}
                mobileUrl={mobileUrl}
                sm={true}
                objectPosition="right top"
                height={500}
                mobileHeight={420}
                emptyAlt
            />
        </StyledImageWrapper>
    )
}
export default ArticleImageHeader
